import React from "react";
import { Route, Routes } from "react-router-dom";
import EmployeeCreate from "../pages/employees/EmployeeCreate";
import EmployeeEvents from "../pages/employees/EmployeeEvents";
import EmployeesList from "../pages/employees/EmployeesList";

export default function EmployeeRoutes() {
  return (
    <Routes>
      <Route path="" element={<EmployeesList />} />
      <Route path="/create" element={<EmployeeCreate />} />
      <Route path="/:employee" element={<EmployeeEvents />} />
    </Routes>
  );
}
